<template>
    <div class="font-prompt">
        <b-modal :id="modalId"
                 modal-class="modal-success-page"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base font-prompt">
                <div class="modal-base-head">
                    <top-bar></top-bar>
                </div>
                <div class="modal-base-body">
                    <div class="modal-success-title">ลงทะเบียนสำเร็จ</div>

                    <div v-if="type == 'ticket'">
                        <div class="modal-success-message">
                            กรุณาแสดงข้อความนี้เพื่อรับสิทธิ์เข้าร่วม<br>กิจกรรมของชาเนล
                        </div>
                        <div class="p-2">
                            <button class="btn-black" @click="clickSubmit()">รับสิทธิ์เข้าร่วมกิจกรรม</button>
                        </div>
                    </div>
                    <div v-else>
                        <div class="modal-success-message">
                            กรุณาแสดงข้อความนี้เพื่อรับผลิตภัณฑ์ขนาดทดลอง ที่เคาน์เตอร์ความงามชาเนล
                        </div>
                        <div class="p-2">
                            <button class="btn-black" @click="clickSubmit()">รับผลิตภัณฑ์ขนาดทดลอง</button>
                        </div>
                    </div>
                </div><!-- modal-base-body -->
            </div><!-- modal-base -->
        </b-modal>
    </div>
</template>
<script>
import TopBar from '@/components/TopBar.vue';
import Account from "@/helper/AccountHelper.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
/**
 * @property {Vue} busModal
 *
 * @method showModal
 * @method hideModal
 */
export default {
    name: "ModalSuccessPage",
    props: {
        busModal: Object,
    },
    components: {
        TopBar,
    },
    data: function() {
        return {
            modalId: "modal-success-page",
            type: "campaign", // ticket, campaign
            paramStr: "",
            tracking: new TrackingService(this),
        };
    },
    mounted: function() {
        this.busModal.$on('showModal', this.showModal);
        this.busModal.$on('hideModal', this.hideModal);
    },
    methods: {
        showModal: function(data) {
            this.type = data.type;
            if (data.paramStr) {
                this.paramStr = data.paramStr;
            }
            this.$bvModal.show(this.modalId);
        },
        clickSubmit: function() {
            if (this.type == 'ticket') {
                
                this.tracking.event("regis_success", "click_regis_success_ticket");
            } else {
                
                this.tracking.event("regis_success", "click_regis_success_sampling");
            }
            setTimeout(() => {

                if (Account.getCacheCustom("Formliff")) {

                    this.paramStr = encodeURIComponent(this.paramStr);

                    window.location.href = "/landing/line?liff.state=" + this.paramStr;
                } else {
                    window.location.href = "/landing/line" + this.paramStr;
                }
                    
            }, 500);
            
            
            //window.location.href = "/landing/line" + this.paramStr;
            //%3Ftarget_page%3Dcampaign%26campaignid%3D91677
            ///landing/line?liff.state=%3FboutiqueId%3Dxxxx%26target_page%3Dcampaign%26campaignid%3D91677
            // window.location.href = "/landing/line?liff.state=%3FboutiqueId%3Dxxxx%26sourceId%3Dyyyy%26target_page%3Dcampaign%26campaignid%3D549070&state=line_authorize";
        },
        hideModal: function() {
            this.$bvModal.hide(this.modalId);
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/base/component/modal/ModalFullScreen.scss";

    .modal-success-page {
        @extend %modal-base;

        .modal-success-title {
            font-size: 1.2rem;
            font-weight: bold;
            text-decoration: underline;
            text-align: center;
            padding-top: 25vh;
        }

        .modal-success-message {
            text-align: center;
            line-height: 1.2;
            font-size: 0.9rem;
            padding: 20px;
        }
    }
</style>
